const HTML_TAG_RE = /<\/?[a-z][\s\S]*>/i;
const RICH_MARKER_RE = /data-lh6-formula|data-formula|lh6-katexFormula|<img\b|<table\b/i;

export function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function looksLikeRichHtml(value = "") {
  const raw = String(value || "");
  return HTML_TAG_RE.test(raw) || RICH_MARKER_RE.test(raw);
}

export function normalizeRichHtmlForDisplay(value = "", fallback = "") {
  const raw = String(value || "").trim();
  if (!raw) return fallback ? `<p>${escapeHtml(fallback)}</p>` : "";
  if (looksLikeRichHtml(raw)) return raw;
  return `<p>${escapeHtml(raw).replace(/\n/g, "<br>")}</p>`;
}

export function richHtmlToPlainText(value = "") {
  const raw = String(value || "");
  if (!raw) return "";

  if (typeof DOMParser === "undefined") {
    return raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  const doc = new DOMParser().parseFromString(`<div>${normalizeRichHtmlForDisplay(raw)}</div>`, "text/html");
  return (doc.body?.textContent || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
}

export function hasMeaningfulRichHtml(value = "") {
  const raw = String(value || "").trim();
  if (!raw) return false;
  if (!looksLikeRichHtml(raw)) return raw.replace(/\s+/g, "").length > 0;

  if (typeof DOMParser === "undefined") {
    return raw.replace(/<[^>]*>/g, "").replace(/\s+/g, "").length > 0;
  }

  const doc = new DOMParser().parseFromString(`<div>${raw}</div>`, "text/html");
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return false;
  if (
    wrapper.querySelector(
      'img, table, math, svg, iframe, video, audio, span[data-formula], span[data-lh6-formula], .lh6-katexFormula'
    )
  ) {
    return true;
  }
  return (wrapper.textContent || "").replace(/\u00a0/g, " ").trim().length > 0;
}
